import { Toast } from '../../../../components/Common/Toast';
import { callAPI } from '../../../../services/api.service';
import { UserModel } from '../../../../interfaces/user.interface';

export interface StudentsFilters {
  classroomId?: string;
  teacherEmail?: string;
  sortBy?: string;
  sortByValue?: string;
}

export const fetchStudents = async (
  currentPage: number,
  filters: StudentsFilters = {},
  search?: string,
): Promise<{ users: UserModel[]; totalPages: number; totalRecords: number }> => {
  try {
    const params = new URLSearchParams();
    params.set('pageNumber', String(currentPage));
    if (filters.classroomId) params.set('classroomId', filters.classroomId);
    if (filters.teacherEmail) params.set('teacherEmail', filters.teacherEmail);
    if (filters.sortBy) params.set('sortBy', filters.sortBy);
    if (filters.sortByValue) params.set('sortByValue', filters.sortByValue);
    if (search) params.set('search', search);

    const data = await callAPI(`admin/user/students?${params.toString()}`);
    return {
      users: data?.users || [],
      totalPages: data?.totalPages || 0,
      totalRecords: data?.totalRecords || 0,
    };
  } catch (error) {
    Toast('Error fetching students', true);
    throw error;
  }
};

export const fetchAllClassroomStudents = async (classroomId: string): Promise<UserModel[]> => {
  try {
    const params = new URLSearchParams();
    params.set('classroomId', classroomId);
    params.set('noPagination', 'true');
    params.set('sortBy', 'name');
    params.set('sortByValue', 'asc');

    const data = await callAPI(`admin/user/students?${params.toString()}`);
    return data?.users || [];
  } catch (error) {
    Toast('Error fetching classroom students', true);
    throw error;
  }
};

export const searchStudents = async (searchText: string): Promise<UserModel[]> => {
  try {
    const response = await callAPI(`admin/user/students/search?search=${encodeURIComponent(searchText)}`);
    return response?.message || [];
  } catch (error) {
    Toast('Error searching students', true);
    throw error;
  }
};
